import React from "react";
import { Redirect } from "react-router-dom";
import { Mutation } from "react-apollo";
import { DELETE_ORGANIZATION } from "../../../graphql";
import Button from "../../UI/Button";
import OrganizationSelect from "../../Organization/Select/Container"

import {
  Spacer,
  Tgrid,
  tbGrids
} from "../../../components/Layout/Layout";

class OrganizationDeleteForm extends React.Component {
  state = {
    organizationID: ""
  };

  handleInputChange = (name, value) => {
    this.setState({
      [name]: value
    });
  };

  
  render() {
    return (
      <Mutation mutation={DELETE_ORGANIZATION}>
        {(deleteOrganization, { data, loading, called, error }) => {
          if (called && !error && !loading) {
            if (data.deleteOrganization) {
              return (
                <Redirect
                  to={{
                    pathname: "/",
                    state: {
                      message: `Organization ${
                        data.deleteOrganization.name
                      } successfully deleted`
                    }
                  }}
                />
              );
            }
          }

          return (
            <React.Fragment>
                <form
                onSubmit={e => {
                  e.preventDefault();
                  deleteOrganization({ variables: { id: this.state.organizationID } });
                }}
              >
                <Spacer>
                  
                  <Tgrid gr={tbGrids.grid70}>
                  <Spacer>
                      <OrganizationSelect required onChange={value=>this.handleInputChange("organizationID",value)}/>
                    </Spacer>
                  </Tgrid>
                  <Tgrid gr={tbGrids.grid30}>
                  <Spacer><Button type="submit" disabled={loading}>
                      Delete
                    </Button></Spacer>

                  
                  </Tgrid>
                  
                </Spacer>
              </form>
              
            </React.Fragment>
          );
        }}
      </Mutation>
    );
  }
}

export default OrganizationDeleteForm;